<template>
	<div class="view-wrapper impressum" v-if="document">
		<div class="container">
			<h1>{{ document.title }}</h1>
			<div>
				<c-flex-content :content="document.flex_content" />
			</div>
		</div>
	</div>
</template>

<script>
import * as utils from '@/utils/utils'
import defaultHeadData from '@/utils/defaultHeadData'
import getImpressumData from '@/api/impressum.wp.api'
import CFlexContent from '@/components/FlexContent'

export default {
	name: 'about',
	components: {
		CFlexContent
	},
	data: () => ({
		documentData: {},
		headData: defaultHeadData
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta
		},
		siteSettings() {
			return this.$store.state.general.siteSettings
		},
		activeRouteUrl() {
			return utils.constructActiveRouteUrl(this.$route.fullPath)
		},
		document() {
			return this.documentData
		}
	},
	watch: {
		'$route': function() {
			this.setImpressumData()
			this.updateHeadData()
		},
		defaultMeta: function() {
			this.updateHeadData()
		}
	},
	head: {
		title: function() {
			return utils.transformHeadTitle(this.headData.title)
		},
		meta: function() {
			return utils.transformHeadMeta(this.headData.meta)
		},
		link: function() {
			return utils.transformHeadLink({ data: this.headData.link, i18n: false })
		}
	},
	beforeMount() {
		this.setImpressumData()
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/impressum' })
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/impressum' })

	},
	methods: {
		setImpressumData() {
			this.documentData = null
			getImpressumData({ lang: this.settings.currentLang }).then(payload => {
				this.documentData = payload
				utils.setHtmlLang(this.settings.currentLang)
				this.updateHeadData()
			})
		},
		updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = utils.transformHeadData({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				})
				this.$emit('updateHead')
			}
		}
	}
}
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.impressum {
		padding: 2rem 0 6rem;

		p + p {
			margin-top: 1rem;
		}
		h3 {
			margin: 2rem 0 1rem 0;
			font-weight: 600;
		}
	}

</style>



// WEBPACK FOOTER //
// Impressum.vue?78a4999c